export class RentalAgreementSetting{
    id : number;
    email : string;
    webSite : string;
    address : string;
    telephone : string;
}